import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

function ForgotPassword() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const { resetPassword } = useAuth();

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setMessage('');
            setError('');
            setLoading(true);
            await resetPassword(email);
            setMessage(t('auth_reset_email_sent'));
        } catch (err) {
            setError(t('auth_reset_failed') + err.message);
        }
        setLoading(false);
    }

    return (
        <div className="page-section">
            <div className="auth-container">
                <h2 className="section-title">{t('auth_forgot_password_title')}</h2>
                <p className="auth-subtitle">{t('auth_forgot_password_subtitle')}</p>

                {error && <div className="error-banner">{error}</div>}
                {message && <div className="success-banner">{message}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="email">{t('auth_email')}</label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={t('auth_email_placeholder')}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn-primary-modern"
                        disabled={loading}
                    >
                        {loading ? t('auth_sending') : t('auth_reset_password_btn')}
                    </button>
                </form>

                <p className="auth-link">
                    <Link to="/login">{t('auth_back_to_login')}</Link>
                </p>
            </div>
        </div>
    );
}

export default ForgotPassword;
